import { render, staticRenderFns } from "./UserLogs.vue?vue&type=template&id=0eb11fca&scoped=true"
import script from "./UserLogs.vue?vue&type=script&lang=js"
export * from "./UserLogs.vue?vue&type=script&lang=js"
import style0 from "./UserLogs.vue?vue&type=style&index=0&id=0eb11fca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb11fca",
  null
  
)

export default component.exports